import { Flex } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"
import Image from "next/image"




const Namads = () => {

    const mobileMatches = useMediaQuery('(max-width: 768px)')



    return (
        <Flex
            align="center"
            gap={10}
            pos="relative"
        >
            <div>
                <a
                    referrerPolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=253038&amp;Code=6nrQBQ7uzhr3PpeNrEfl"
                >
                    <Image
                        referrerPolicy="origin"
                        src="https://Trustseal.eNamad.ir/logo.aspx?id=253038&amp;Code=6nrQBQ7uzhr3PpeNrEfl"
                        alt="enamad"
                        style={{ cursor: "pointer" }}
                        id="6nrQBQ7uzhr3PpeNrEfl"
                        width={mobileMatches ? 35 : 56}
                        height={mobileMatches ? 39 : 62}
                        objectFit="contain"
                        className="object-fit-contain"
                    />
                </a>
            </div>
            <div>
                <Image
                    width={mobileMatches ? 40 : 63}
                    height={mobileMatches ? 40 : 63}
                    src="/images/certifications/samandehi.png?id=289237&p=odrfaqgwbsiyodrfqftiyndt"
                    referrerPolicy="origin"
                    id="nbqeoeuksizpnbqergvjjzpe"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                        typeof window !== "undefined" &&
                        window.open(
                            "https://logo.samandehi.ir/Verify.aspx?id=289237&p=uiwkmcsipfvluiwkxlaojyoe",
                            "Popup",
                            "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
                        )
                    }
                    alt="logo-samandehi"
                    className="object-fit-contain"
                />
            </div>
            <div>
                <Image
                    width={mobileMatches ? 46 : 72}
                    height={mobileMatches ? 46 : 72}
                    src={"/images/namads/etehadie.svg"}
                    referrerPolicy="origin"
                    id="nbqeoeuksizpnbqergvjjzpe"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                        window.open(
                            "https://ecunion.ir/verify/salamsakhteman.com?token=2336607625d3327e9c47",
                            "Popup",
                            "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30"
                        )
                    }
                    alt="ecunion"
                    className="object-fit-contain"
                />
            </div>
        </Flex>
    )
}

export default Namads